import {
	ChartSubType,
	ConnectorSubType,
	DepotSubType,
	DcCoreElementType,
	GridSubType,
	SimpleType,
} from '../dc-core-types';

type ElementType =
	| string
	| `${DcCoreElementType}`
	| DcCoreElementType
	| undefined;

type ElementSubType<T extends ElementType> = T extends 'CHART'
	? ChartSubType | `${ChartSubType}`
	: T extends 'GRID'
	? GridSubType | `${GridSubType}`
	: T extends 'DEPOT'
	? DepotSubType | `${DepotSubType}`
	: T extends 'CONNECTOR'
	? ConnectorSubType | `${ConnectorSubType}`
	: T extends string | SimpleType | `${SimpleType}`
	? string
	: never;

export class DcRouteUrlBuilder {
	public static buildEditPageUrl<T extends ElementType | `${ElementType}`>(
		projectId: number,
		elementId: number | undefined,
		elementType: T,
		elementSubType?: ElementSubType<T>
	): string {
		if (projectId === -1) {
			return '/project/';
		}
		if (
			elementType === undefined ||
			elementId === undefined ||
			elementId === -1
		) {
			return `/project/${projectId}/edit`;
		}
		switch (elementType) {
			case DcCoreElementType.DASHBOARD:
				return `/project/${projectId}/dashboard/edit/${elementId}`;
			case DcCoreElementType.MAP:
				return `/project/${projectId}/map/edit/${elementId}`;
			case DcCoreElementType.TIMELINE:
				return `/project/${projectId}/timeline/edit/${elementId}`;
			case DcCoreElementType.MEDIA:
				return `/project/${projectId}/media/edit/${elementId}`;
			case DcCoreElementType.ENTITY:
				return `/project/${projectId}/entity/edit/${elementId}`;
			case DcCoreElementType.DATABLOCK:
				return `/project/${projectId}/datablocks/edit/${elementId}`;
			case DcCoreElementType.EXPORT_TEMPLATE:
				return `/project/${projectId}/miscellaneous/export/${elementId}`;
			case DcCoreElementType.EXPOSITION:
				return `/project/${projectId}/exposition/${elementId}/view`;
			case DcCoreElementType.RANKING:
				return `/project/${projectId}/rankings/edit/${elementId}`;
			case DcCoreElementType.CHART:
				return `/project/${projectId}/chart/${elementSubType}/edit/${elementId}`;
			case DcCoreElementType.GRID:
				return `/project/${projectId}/grid/${elementSubType}/edit/${elementId}`;
			case DcCoreElementType.CONNECTOR:
				return `/project/${projectId}/connector/edit/${elementSubType?.toUpperCase()}/${elementId}`;
			case DcCoreElementType.DEPOT:
				return `/project/${projectId}/depot/edit/${elementSubType?.toUpperCase()}/${elementId}`;
			default:
				return '/project/';
		}
	}
}
